import type { Step } from "react-joyride";

export const otRequestFormForEmployeeTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້ານີ້ໃຊ້ສ້າງຄຳຂໍ OT ໃຫ້ພະນັກງານອື່ນ. ເລືອກພະນັກງານກ່ອນ ແລ້ວຕື່ມວັນທີ, ເວລາ ແລະ ເຫດຜົນ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="ot-request-for-employee-back"]',
    content: "ກັບໄປລາຍການອະນຸມັດ OT.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="ot-request-for-employee-employee"]',
    content: "ເລືອກພະນັກງານທີ່ຕ້ອງການສ້າງຄຳຂໍ OT ໃຫ້.",
    placement: "top",
  },
  {
    target: '[data-tourid="ot-request-for-employee-form"]',
    content:
      "ຕື່ມວັນທີ່ເຮັດວຽກ, ເວລາເລີ່ມ-ສິ້ນສຸດ ແລະ ເຫດຜົນ. ກົດສົ່ງຄຳຂໍເມື່ອຕື່ມຄົບ.",
    placement: "top",
  },
];
